<template>
  <v-app>
    <app-bar></app-bar>
       <v-main>
      <router-view />
    </v-main>
    <the-footer></the-footer>
  </v-app>
</template>

<script>
import AppBar from "../src/components/AppBar.vue";
import TheFooter from "../src/components/TheFooter.vue";
export default {
  name: "App",
  components: {
    AppBar,
    TheFooter,
  },
  
};
</script>

<style lang="scss">
:root {
  --color-primary: #eb2f64;
  --color-primary-light: #ff3366;
  --color-primary-dark: #263238;

  --color-Grey-light-1: #faf9f9;
  --color-Grey-light-2: #f4f2f2;
  --color-Grey-light-3: #f0eeee;
  --color-Grey-light-4: #ccc;

  --color-Grey-dark-1: #333;
  --color-Grey-dark-2: #777;
  --color-Grey-dark-3: #999;

  --shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);
  --shadow-light: 0 2rem 5rem rgb(0, 0, 0, 0.06);

  --line: 1px solid var(--color-Grey-light-2);
}
h1 {
  font-size: 24px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 3px;
  line-height: 1;
}
h2 {
  text-transform: uppercase;
  line-height: 1;
  // color: var(--color-primary);
}
</style>
